
import {
	Vue,
	Component,
	Prop,
	PropSync,
	Watch,
	Inject
} from "vue-property-decorator";
import Marquee from "@/components/semantics/Marquee.vue";
import SortHeader from "@/components/base/table/header/SortHeader.vue";
import { Action, Getter, State } from "vuex-class";
import Pagination from "@components/base/pagination/PcmPagination.vue";
import { getAreaCN, deepClone, getParentArea } from "@/common/utils";
import { pageViewUnit } from "@/config";

@Component({
	name: "Apply",
	components: {
		Marquee,
		SortHeader,
		Pagination
	}
})
export default class Apply extends Vue {
	@Action("policy/getPolicyList") private getPolicyList: any;
	@Getter("cityName") private cityName: any;
	@Getter("cityId") private cityId: any;
	areaOption = this.$root.$data.areaOption;
	loading = false;
	tableData: any = [];
	pages = 0;
	total = 0;
	current = 1;
	size = 10;
	current_option: any = {};
	preSearch: any = "";
	created() {
		const searchData = this.$route.params.search;
		if (searchData) {
			this.preSearch = searchData;
			this.current_option = {
				likeParam: searchData
			};
			this.getData(1);
		} else {
			this.getData(0);
		}
	}
	async getData(type: any) {
		// 0-default|1-search

		const provinceItem: any = getParentArea(this.areaOption, this.cityId);
		const provinceId = provinceItem.value;
		const allArea: any = [];
		const tempAreaOption = deepClone(this.areaOption);
		allArea.push(provinceId);
		allArea.push(String(this.cityId));
		const tempArea = tempAreaOption.filter((province: any) => {
			province.children = province.children
				.filter((city: any) => {
					const provinceItem: any = getParentArea(this.areaOption, city.value);
					const provinceId = provinceItem ? provinceItem.value : "";
					return city.value === this.cityId || provinceId === this.cityId;
				})
				.map((city: any) => {
					city.children.map((area: any) => {
						allArea.push(area.value);
						return area;
					});
					return city;
				});
			return province.value === provinceId;
		});
		this.loading = true;
		let options: any = {
			current: this.current,
			size: this.size,
			addressCodeList: allArea
		};
		this.current_option.addressCodeList = allArea;
		if (type === 1) {
			if (options.addressCode || this.current_option.addressCode) {
				this.current_option.addressCodeList = null;
			}
			options.addressCodeList = null;
			options = {
				...options,
				...this.current_option
			};
		}
		setTimeout(() => {
			this.loading = false;
		}, 30000);
		this.getPolicyList(options).then(({ code, data, msg }: any) => {
			if (code === 0) {
				this.loading = false;
				const { total, records, pages } = data;
				this.tableData = records.map((item: any) => {
					item.pageView = (item.pageView || 0) + pageViewUnit;
					item.addressCN = getAreaCN(this.areaOption, item.addressCode);
					return item;
				});
				this.total = total;
				this.pages = pages;
			}
		});
	}
	clickMarquee(options: any) {
		options.addressCode ? options.addressCode : this.cityId;
		this.current_option = options;
		this.getData(1);
	}
	toDetail({ id: policyId }: any, column: any, e: any) {
		this.$router.push({
			path: "/kunmingdetail/policy",
			query: {
				policyId
			}
		});
	}
	search(options: any) {
		this.current_option = {
			...this.current_option,
			...options
		};
		this.getData(1);
	}
	currentChange(params: any) {
		this.current = params;
		this.getData(1);
	}
}
